import { gql } from '@apollo/client'
import { ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT } from '../fragments/ZoneHierarchyGlobalSearchResultFragment'

export const ZONE_HIERARCHY_GLOBAL_SEARCH = gql`
  query ZoneHierarchyGlobalSearch($searchTerm: String!) {
    zoneHierarchyGlobalSearch(searchTerm: $searchTerm) {
      areas {
        ...ZoneHierarchyGlobalSearchResult
      }
      people {
        ...ZoneHierarchyGlobalSearchResult
      }
      stores {
        ...ZoneHierarchyGlobalSearchResult
      }
    }
  }
  ${ZONE_HIERARCHY_GLOBAL_SEARCH_RESULT_FRAGMENT}
`
